export default {
  nav: {
    home: "الرئيسية",
    engines: "المحركات",
    transmissions: "ناقل الحركة",
    bodyParts: "قطع الهيكل",
    testimonials: "آراء العملاء",
    contact: "اتصل بنا",
    getQuote: "اطلب عرض سعر",
    menu: "فتح القائمة",
  },
  banner: {
    text: "تخفيضات كبيرة الآن — خصم يصل إلى 30% على محركات ونواقل حركة وقطع هيكل مختارة. الشحن متاح في جميع أنحاء أستراليا.",
  },
  hero: {
    badge: "موثوق منذ 2005",
    title1: "محركات مستعملة عالية الجودة و",
    titleHighlight: "ناقل حركة",
    desc: "{{siteName}} هو متجرك الشامل لقطع الغيار المستعملة والجديدة وقطع ما بعد البيع، مع الشحن إلى جميع أنحاء أستراليا. متخصصون في أشهر سيارات البيك أب وسيارات الدفع الرباعي في السوق الأسترالية.",
    contact: "اتصل بنا",
    browse: "تصفح المحركات",
  },
  about: {
    f1title: "شركة عائلية",
    f1text: "{{siteName}} شركة عائلية في داروين تأسست على الثقة والعمل الجاد والاهتمام الحقيقي بكل عميل نخدمه.",
    f2title: "السمعة",
    f2text: "نتمتع بسمعة قوية بُنيت على النزاهة والإنصاف والمعرفة التقنية في قطع الغيار المستعملة والجديدة وقطع ما بعد البيع.",
    f3title: "ماذا نفعل",
    f3text: "نحن متجرك الشامل لقطع الغيار المستعملة والجديدة وقطع ما بعد البيع، بدعم من ورشة خدمة وإصلاح متخصصة.",
    f4title: "ذوو مهارة عالية",
    f4text: "يستخدم فنيّونا ذوو الخبرة أحدث برامج التشخيص والماسحات الضوئية لمساعدتك على تجنب تكاليف الإصلاح غير الضرورية.",
    stockLabel: "ماذا لدينا في المخزون",
    modelsTitle: "الطرازات الشائعة التي نغطيها",
    modelsDesc: "نركّز على سيارات البيك أب وسيارات الدفع الرباعي الأسترالية الأكثر مبيعاً حتى تحصل على القطعة الصحيحة بسرعة.",
  },
  why: {
    promise: "وعدنا",
    title: "لماذا تختارنا",
    w1title: "الجودة",
    w1text: "راحة البال بمعرفتك أنك حصلت على قطعة وخدمة عالية الجودة في كل مرة.",
    w2title: "التوفير",
    w2text: "احتفظ بمزيد من المال في جيبك بفضل خصوماتنا الممتازة على جميع القطع، الجديدة والمستعملة.",
    w3title: "الضمان",
    w3text: "القطع الجديدة تأتي بضمان 12 شهراً والقطع المستعملة بضمان 3 أشهر.",
    w4title: "الشحن",
    w4text: "تُشحن القطع الصغيرة في نفس اليوم، والأكبر حجماً خلال يوم إلى 3 أيام في جميع أنحاء أستراليا.",
    missionTitle: "مهمتنا",
    missionText: "أن نقدم لك، ولعملائنا ومجتمعنا، خدمة عملاء عالمية المستوى. نهدف إلى تحقيق أعلى جودة في كل ما نقوم به لخدمتك على أفضل وجه — من خلال ركائز القيم الأربع لدينا: العائلة، والدافع، والابتكار، والجودة.",
    valuesTitle: "قيمنا",
    v1label: "العائلة",
    v1text: "نحن فريق واحد نهتم بعملائنا وأفرادنا وموردينا.",
    v2label: "الدافع",
    v2text: "نسعى لتحقيق الأفضل فيما نقوم به، بشغف حقيقي نحو النجاح.",
    v3label: "الابتكار",
    v3text: "نفكر خارج الصندوق ونعمل بجد للتحسين المستمر.",
    v4label: "الجودة",
    v4text: "نسعى لفعل الأشياء بشكل صحيح من المرة الأولى، في كل مرة.",
    t1text: "خدمة رائعة. أُنجز العمل في نفس اليوم وتواصلوا معي طوال الوقت — كل ذلك بسعر ممتاز!",
    t1name: "نيكو أ.",
    t1loc: "داروين",
    t2text: "وجدت المحرك الذي أحتاجه بالضبط لسيارتي هايلوكس. ودودون وصادقون وذوو معرفة حقيقية بسيارات البيك أب الأسترالية. أوصي بهم بشدة.",
    t2name: "كريس ن.",
    t2loc: "بالمرستون",
    t3text: "مفيدون جداً وعادلون وصادقون، مع قطع مستعملة عالية الجودة لجميع الطرازات الشائعة. تقييم ممتاز!",
    t3name: "ستيفن س.",
    t3loc: "داروين",
    t4text: "حضرت بمشاكل غير معروفة، وأعادني هؤلاء إلى الطريق بسرعة. خدمة رائعة.",
    t4name: "أرماند د.",
    t4loc: "كاثرين",
  },
  brand: {
    strip: "قطع لجميع الماركات الرئيسية",
  },
  cta: {
    title: "تبحث عن قطعة؟",
    desc: "أخبرنا بما تحتاجه وسيوفره لك فريقنا. نشحن في جميع أنحاء أستراليا من ورشتنا في وينلي، داروين.",
    request: "اطلب عرض سعر",
  },
  footer: {
    brandDesc: "مصدر أستراليا الموثوق للمحركات المستعملة ونواقل الحركة وقطع الهيكل عالية الجودة. شركة عائلية تركز على أشهر سيارات البيك أب وسيارات الدفع الرباعي الأسترالية.",
    quickLinks: "روابط سريعة",
    company: "الشركة",
    getInTouch: "تواصل معنا",
    monFri: "الإثنين - الجمعة: 8:00 صباحاً - 5:00 مساءً",
    copyright: "© حقوق الطبع والنشر {{year}} {{siteName}}. جميع الحقوق محفوظة.",
    disclaimer: "{{siteName}} متخصص مستقل في قطع الغيار والخدمات.",
  },
  page: {
    enginesSubtitle: "محركات مستعملة وجديدة ومجددة عالية الجودة لجميع الماركات والطرازات – الأوروبية واليابانية والأمريكية. يتم فحص كل محرك وختمه وتزويده بالضمان.",
    transmissionsSubtitle: "نواقل حركة أوتوماتيكية ويدوية، مستعملة وجديدة، لجميع الماركات والطرازات – الأوروبية واليابانية والأمريكية. يتم فحص كل ناقل حركة واختباره وتزويده بالضمان.",
    bodyPartsSubtitle: "ألواح هيكل وصدامات ومرايا وأضواء وزخارف مستعملة وقطع ما بعد البيع لجميع الماركات والطرازات. ألواح مستقيمة بأسعار تنافسية مع ضمان.",
  },
  grid: {
    ourStock: "مخزوننا",
    itemsInStock: "{{count}} قطعة في المخزون",
    shipping: "شحن في جميع أنحاء أستراليا",
    price: "السعر",
    enquire: "استفسر الآن",
    searchPlaceholder: "ابحث بالماركة أو الطراز أو اسم القطعة...",
    allMakes: "جميع الماركات",
    allModels: "جميع الطرازات",
    noResults: "لا توجد قطع تطابق بحثك. جرّب ماركة أو طرازاً آخر.",
    clearFilters: "مسح الفلاتر",
  },
  availability: {
    badge: "تحديث المخزون",
    title: "مستعمل وجديد {{category}}",
    text: "لدينا محركات ونواقل حركة وقطع هيكل لجميع الماركات والطرازات. نقدم مجموعة واسعة من المحركات ونواقل الحركة وقطع الهيكل للسيارات الأوروبية واليابانية والكندية والأمريكية. جميع القطع مفحوصة وتلبي متطلبات الجودة التي تخضع لها؛ وكل قطعة مختومة وتحمل علامة خاصة. جميع القطع المستعملة تأتي بضمان جودة طويل الأمد. إذا كانت لديك أي شكوك حول اختيار محركك أو ناقل الحركة أو قطعة الهيكل، يرجى التواصل مع فريقنا – يسعدنا الإجابة على أسئلتك وتقديم استشارة شاملة. {{siteName}} – بحث مريح عن القطع المستعملة والجديدة، مع توصيل سريع للبضائع خلال 1–3 أيام عمل بعد استلام الدفع.",
    cta: "اتصل بنا",
  },
  request: {
    badge: "قطعة مفقودة؟",
    title: "لا تجد القطعة التي تحتاجها؟",
    text: "يوفر {{siteName}} كل أسبوع محركات ونواقل حركة وقطع هيكل يصعب العثور عليها. أخبرنا بالماركة والطراز والسنة — إذا لم تكن متوفرة اليوم، فسيقوم فريقنا بتتبعها والرد عليك بسرعة.",
    cta: "اطلب قطعة",
  },
  partsWeSource: {
    badge: "طلب خاص",
    title: "القطع التي نوفرها",
    desc: "لا ترى ما تبحث عنه؟ يتتبع {{siteName}} كل أسبوع القطع التي يصعب العثور عليها — من وحدات التحكم الإلكترونية وصناديق الكمبيوتر النادرة إلى تلك القطع الفريدة التي لا يخزنها أحد آخر.",
    ecuTitle: "وحدات التحكم الإلكترونية ووحدات التحكم",
    ecuText: "وحدات التحكم في المحرك وناقل الحركة والهيكل، مبرمجة ومختبرة على سيارتك.",
    computerBoxTitle: "صناديق الكمبيوتر",
    computerBoxText: "صناديق كمبيوتر إدارة المحرك والوحدات الموصلة للبيك أب وسيارات الدفع الرباعي وغيرها.",
    hardToFindTitle: "قطع يصعب العثور عليها",
    hardToFindText: "زخارف نادرة وألواح متوقفة وقطع متخصصة من خلال شبكتنا الوطنية.",
    cta: "اطلب قطعة",
  },
  contact: {
    badge: "تواصل معنا",
    title: "اتصل بنا",
    desc: "هل تفكر في قطعة معينة؟ أرسل لنا استفساراً وسيرد عليك فريقنا سريعاً. نشحن في جميع أنحاء أستراليا من وينلي، داروين NT 0820.",
    sendEnquiry: "إرسال استفسار",
    formDesc: "املأ النموذج وسنتواصل معك قريباً.",
    prefill: "لقد ملأنا مسبقاً القطعة التي تستفسر عنها. فقط أضف بياناتك وأي ملاحظات أدناه.",
    name: "الاسم",
    namePlaceholder: "اسمك الكامل",
    email: "البريد الإلكتروني",
    emailPlaceholder: "you@email.com",
    phone: "الهاتف",
    phonePlaceholder: "+61 4xx xxx xxx",
    subject: "الموضوع",
    subjectPlaceholder: "اختر موضوعاً",
    subjectEngine: "استفسار عن محرك",
    subjectTransmission: "استفسار عن ناقل حركة",
    subjectBody: "استفسار عن قطعة هيكل",
    subjectGeneral: "استفسار عام",
    subjectSpecialOrder: "طلب خاص / طلب قطعة",
    part: "القطعة / العنصر المستفسر عنه",
    partPlaceholder: "مثال: محرك – تويوتا هايلوكس 2018",
    vehicle: "المركبة (الماركة والطراز والسنة)",
    vehiclePlaceholder: "مثال: تويوتا هايلوكس 2018",
    notes: "ملاحظات",
    notesPlaceholder: "أخبرنا بالقطعة التي تبحث عنها...",
    maxChars: "بحد أقصى 500 حرف",
    partPhoto: "صورة القطعة (اختياري)",
    partPhotoHint: "JPG أو PNG أو WebP، حتى 8 ميجابايت. يساعدنا في تحديد القطعة بدقة بشكل أسرع.",
    choosePhoto: "اختر صورة",
    removePhoto: "إزالة الصورة",
    photoInvalid: "يرجى اختيار ملف صورة (JPG أو PNG أو WebP).",
    photoTooLarge: "هذه الصورة كبيرة جدًا. يرجى اختيار صورة أقل من 8 ميجابايت.",
    success: "شكراً لاستفسارك! سنرد عليك قريباً.",
    sending: "جارٍ الإرسال...",
    send: "إرسال الاستفسار",
    details: "بياناتنا",
    addressLabel: "العنوان",
    phoneLabel: "الهاتف",
    emailLabel: "البريد الإلكتروني",
    hoursLabel: "ساعات العمل",
    sat: "السبت: بموعد مسبق",
  },
  detail: {
    home: "الرئيسية",
    photos: "الصور",
    specifications: "المواصفات",
    make: "الماركة",
    model: "الطراز",
    year: "السنة",
    fitment: "التوافق",
    condition: "الحالة",
    warranty: "الضمان",
    notFound: "تعذر العثور على هذه القطعة. ربما تم بيعها أو إزالتها.",
    backHome: "العودة إلى الرئيسية",
    backToList: "العودة إلى القائمة",
  },
};